import Api from "./Api";
import Cookie from "js-cookie";
import axios from "axios";

export default {
  async getCookie() {
    let token = Cookie.get("XSRF-TOKEN");
    if (token) {
      console.log("No hay token: " + token);
      //
      return new Promise(resolve => {
        resolve(token);
      });
    }
    let regex = /spa$/g;
    let url = Api.defaults.baseURL.replace(regex, "csrf-cookie");
    return axios.get(url);
    /*content.then(d => {
      console.log(d);
    });
    console.log("Se obtuvo el token! ");
    console.log(content);
    console.log(Promise.resolve(content));*/
  },

  async login(form) {
    await this.getCookie();
    return Api.post("/login", form);
    /* try {
      await this.getCookie();
      let r = await Api.post("/login", form);
      console.log(r);
      if (Object.prototype.hasOwnProperty.call(r, "data")) {
        r = r.data;
        if (Object.prototype.hasOwnProperty.call(r, "token")) {
          localStorage.setItem("token", r.token);
          window.location("/");
          return r;
        }
      }
    } catch (error) {
      console.log("Error\n");
      console.log(error);
      return error;
    }*/
  },

  async logout() {
    localStorage.removeItem("token");
    Cookie.remove("XSRF-TOKEN");
    return Api.post("/logout");
  },

  auth() {
    return Api.get("/user");
  },

  /// CRUD
  async paginate(data) {
    await this.getCookie();
    return Api.post("/users/paginate", data);
  },

  async empleados_repartidores() {
    return Api.get("/empleados/repartidores");
  },

  async repartidor_ver(repartidor_id) {
    return Api.get(`/users/repartidor_ver/${repartidor_id}`);
  },

  async repartidores_list() {
    return Api.get("/users/repartidores_list");
  },

  async agregar_repartidor(data) {
    return Api.post("/users/agregar_repartidor", data);
  },

  async generar_pin(empleado_id) {
    try {
      let response = await Api.post("/users/generar_pin", { empleado_id });
      if (Object.hasOwnProperty.call(response.data, "pin")) {
        return response.data.pin;
      }
      alert("login no existe pin:\n" + JSON.stringify(response.data));
      throw new URIError("Login incorrecto: URI: " + JSON.stringify(response));
    } catch (error) {
      return null;
    }
  },

  async ver(user_id) {
    return Api.get("/users/ver/" + user_id);
  },
  async guardar(form) {
    return Api.post("/users/guardar", form);
  },
  async borrar(user_id) {
    return Api.post("/users/borrar", { id: user_id });
  }
};
